<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<div>
    <h3 *ngIf="!evidencewithtemp.evidenceDto.evidenceType" id="evidence-header-no-type">
        <span id="{{num}}-ev-header-prefix-no-type">{{ 'evidences.group.prefix' | translate }} {{ num + ': ' }}</span>
        <strong id="{{num}}-ev-header-name-no-type">{{'evidences.group.' + evidencewithtemp.evidenceDto.evidenceTypeGroup | translate }}</strong>
        <span *ngIf="evidencewithtemp.evidenceDto.description"> ({{evidencewithtemp.evidenceDto.description}})</span>
        <span class="ic-warning-head" *ngIf="evidencewithtemp.evidenceDto.mandatory"></span>
    </h3>
    <h3 *ngIf="evidencewithtemp.evidenceDto.evidenceType" id="evidence-header">
        <span id="{{num}}-ev-header-prefix">{{ 'evidences.evidence.prefix.description' | translate }} {{ num + ': ' }}</span>
        <strong id="{{num}}-ev-header-name">{{ 'evidences.type.' + evidencewithtemp.evidenceDto.evidenceType.type | translate }}</strong>
        <span *ngIf="evidencewithtemp.evidenceDto.description"> ({{evidencewithtemp.evidenceDto.description}})</span>
        <span class="ic-warning-head"
              *ngIf="evidencewithtemp.evidenceDto.mandatory && evidencewithtemp.evidenceDto.evidenceContentType === 'FORM'"></span>
        <em id="change-evidence-type" class="changeType" (click)="resetType()"
            *ngIf="hasAvailableTypes() && evidencewithtemp.evidenceDto.externalEvidenceStatus !== externalEvidenceStatus.completed">
            {{ 'evidences.changeType' | translate }}
        </em>
    </h3>
</div>

<div *ngIf="!evidencewithtemp.evidenceDto.evidenceType">
    <ul class="evidenceItemChoice content">
        <div *ngFor="let evidenceType of evidencewithtemp.evidenceDto.availableTypes; let index = index">
            <li class="k-button typeChoice" (click)="selectType(evidenceType)"
                id="choiceButton_{{num}}-{{index}}">{{ 'evidences.type.' +
            evidenceType.type | translate }}
            </li>
            <input type="button" class="k-help-typeChoice ic-help" id="help-choiceButton_{{num}}-{{index}}"
                   (click)="openPopoverEvidence('help-choiceButton_'+num+'-'+index)"
                   title="{{ 'evidences.evidence.help' | translate }}"/>
            <span *ngIf="rootScope.get().popoverTable['help-choiceButton_'+num+'-'+index]">
                <app-wl-popover
                        id="{{ 'popover-help-choiceButton_'+num+'-'+index }}"
                        [popoverId]="'popover-help-choiceButton_'+num+'-'+index"
                        [contenttype]="null"
                        [evidencetype]="evidenceType"
                        [partname]="null"
                        [buttonid]="'choiceButton_'+num+'-'+index"
                        [evidencestate]="popoverMode.selectEvidencePart">
                </app-wl-popover>
            </span>
        </div>
    </ul>
</div>
<div *ngIf="evidencewithtemp.evidenceDto.evidenceType">
    <ul class="evidenceItem content">
        <li *ngFor="let part of evidencewithtemp.evidenceDto.parts; let index = index"
            [ngClass]="{'evidencePartItem': part.uploadDate}" class="topLine">
            <app-wl-evidence-part
                    [extevidenceid]="evidencewithtemp.evidenceDto.extEvidenceId"
                    [part]="part"
                    [contenttype]="evidencewithtemp.evidenceDto.evidenceContentType"
                    [mandatory]="evidencewithtemp.evidenceDto.mandatory"
                    [evidencetype]="evidencewithtemp.evidenceDto.evidenceType"
                    [num]="num"
                    [ids]="ids"
                    [numpart]="index+1">
            </app-wl-evidence-part>
        </li>
        <!--        TODO MTSSIGNBOX-1551 add part for MULTI type-->
        <!--        <li *ngIf="(evidencewithtemp.evidenceDto.evidenceContentType === 'MULTI') && (canAddMorePart === true)"-->
        <!--            wl-add-part-->
        <!--            extevidenceid="evidencewithtemp.evidenceDto.extEvidenceId"-->
        <!--            elementtype="elementType" ids="ids"-->
        <!--            evidencetype="evidencewithtemp.evidenceDto.evidenceType"-->
        <!--            class="topLine"></li>-->
    </ul>
</div>